module.exports = __webpack_public_path__ + "static/img/jzgl_p3.7446eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution/jzgl_p3.png
// module id = hoAY
// module chunks = 19